import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-one',
  templateUrl: './explore-one.component.html',
  styleUrls: ['./explore-one.component.scss']
})
export class ExploreOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
